import React, { useContext, useState } from 'react';
import { fullImagePath, generateClassName } from '../../b2b-common/helpers';
import { getImagePathBulletByFrameworkIdAndFwLevelId, getImagePathByFrameworkId } from './helper';

import './FrameworkLogo.css';
import { GenFrameworksContext } from '../../../App';
import { Badge } from '@mui/material';

const FrameworkLogo = ({ framework, className = null, showBadge = true, showOverLay = true }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { genericFrameworks } = useContext(GenFrameworksContext);

    return (
        <div
            onMouseEnter={() => showOverLay && setIsHovered(true)}
            onMouseLeave={() => showOverLay && setIsHovered(false)}
            className={generateClassName('framework-logo', '-container', className)}
        >
            {showBadge && (
                <Badge badgeContent={framework.level1sDTOs.length} color="secondary" className="framework-logo-badge" >
                    <img
                        src={fullImagePath(getImagePathByFrameworkId(genericFrameworks, framework.frameworkDTO.frameworkId))}
                        alt={framework.frameworkDTO.frameworkName}
                        className={generateClassName('framework-logo', '-image', className)}
                    />
                </Badge>
            )}
            {!showBadge && (
                <img
                    src={fullImagePath(getImagePathByFrameworkId(genericFrameworks, framework.frameworkDTO.frameworkId))}
                    alt={framework.frameworkDTO.frameworkName}
                    className={generateClassName('framework-logo', '-image', className)}
                />
            )}
            <div className={generateClassName('framework-logo', '-overlay', className)}>
                {isHovered && framework.level1sDTOs.map(level => {
                    const bulletImage = getImagePathBulletByFrameworkIdAndFwLevelId(genericFrameworks, framework.frameworkDTO.frameworkId, level.levelN_ItemId)
                    const imagePath = bulletImage || level.imagePath;
                    return (
                        <img key={level.levelN_ItemId} src={fullImagePath(imagePath)} alt={level.levelN_ItemName} className="framework-logo-overlay-bullet-image" />
                    );
                })}
            </div>
        </div>
    );
};

export default FrameworkLogo;